// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Card-module__wrapper___KkGYa {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 256px;
  height: 260px;
  padding: 40px 8px;
  border-radius: 42px;
  background: var(--color-surface);
  box-shadow: 4px 8px 24px 5px rgba(0, 0, 0, 0.05);
}

.Card-module__iconBox___DeDLc {
  width: 88px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--color-primary);
}

.Card-module__iconBox___DeDLc svg {
  width: 100%;
  max-width: 50px;
  max-height: 50px;
  fill: var(--color-surface);
}

.Card-module__title___GHLau {
  font: var(--font-h3);
  color: var(--color-black);
  text-align: center;
}

.Card-module__text___uBKO9 {
  font: var(--font-main-min);
  color: var(--color-black);
  text-align: center;
  margin-top: 8px;
}

.Card-module__title___GHLau,
.Card-module__text___uBKO9 {
  white-space: pre-wrap;
}

.Card-module__link___USksR {
  font: var(--font-h3);
  color: var(--color-black);
  text-align: center;
}

.Card-module__exile___gv8F7 {
  font: var(--font-main-min);
  color: var(--color-secondary);
  text-align: center;
  font-weight: 700;
  margin-top: 8px;
  white-space: pre-wrap;
  cursor: pointer;
  transition: all 0.3s ease;
}

.Card-module__exile___gv8F7:hover,
.Card-module__exile___gv8F7:active,
.Card-module__exile___gv8F7:focus {
  color: var(--color-black);
}


@media (min-width: 768px) and (max-width: 1199px) {

  .Card-module__wrapper___KkGYa {
    width: 158px;
    height: 192px;
    padding: 16px 12px;
    border-radius: 30px;
  }

  .Card-module__iconBox___DeDLc {
    width: 42px;
    height: 42px;
    border-radius: 48px;
  }

  .Card-module__iconBox___DeDLc svg {
    max-width: 24px;
    max-height: 24px;
  }

  .Card-module__title___GHLau {
    line-height: normal;
    letter-spacing: -0.5px;
  }

  .Card-module__text___uBKO9 {
    font-size: 14px;
    margin-top: 5px;
  }

  .Card-module__title___GHLau,
  .Card-module__text___uBKO9 {
    white-space: pre-wrap;
  }

  .Card-module__exile___gv8F7 {
    font-size: 14px;
    margin-top: 5px;
    white-space: pre-wrap;
  }
}

@media (min-width: 360px) and (max-width: 767px) {

  .Card-module__wrapper___KkGYa {
    width: 158px;
    height: 192px;
    padding: 16px 12px;
  }

  .Card-module__iconBox___DeDLc {
    width: 42px;
    height: 42px;
  }

  .Card-module__iconBox___DeDLc svg {
    max-width: 24px;
    max-height: 24px;
  }

  .Card-module__title___GHLau {
    line-height: normal;
    letter-spacing: -0.5px;
  }

  .Card-module__text___uBKO9 {
    font-size: 14px;
    margin-top: 5px;
  }

  .Card-module__exile___gv8F7 {
    font-size: 14px;
    margin-top: 5px;
  }

}`, "",{"version":3,"sources":["webpack://./src/entities/card/ui/Card.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;;AAGA;;EAEE;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,qBAAqB;EACvB;AACF;;AAEA;;EAEE;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;AAEF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  width: 256px;\n  height: 260px;\n  padding: 40px 8px;\n  border-radius: 42px;\n  background: var(--color-surface);\n  box-shadow: 4px 8px 24px 5px rgba(0, 0, 0, 0.05);\n}\n\n.iconBox {\n  width: 88px;\n  height: 88px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n  background: var(--color-primary);\n}\n\n.iconBox svg {\n  width: 100%;\n  max-width: 50px;\n  max-height: 50px;\n  fill: var(--color-surface);\n}\n\n.title {\n  font: var(--font-h3);\n  color: var(--color-black);\n  text-align: center;\n}\n\n.text {\n  font: var(--font-main-min);\n  color: var(--color-black);\n  text-align: center;\n  margin-top: 8px;\n}\n\n.title,\n.text {\n  white-space: pre-wrap;\n}\n\n.link {\n  font: var(--font-h3);\n  color: var(--color-black);\n  text-align: center;\n}\n\n.exile {\n  font: var(--font-main-min);\n  color: var(--color-secondary);\n  text-align: center;\n  font-weight: 700;\n  margin-top: 8px;\n  white-space: pre-wrap;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.exile:hover,\n.exile:active,\n.exile:focus {\n  color: var(--color-black);\n}\n\n\n@media (min-width: 768px) and (max-width: 1199px) {\n\n  .wrapper {\n    width: 158px;\n    height: 192px;\n    padding: 16px 12px;\n    border-radius: 30px;\n  }\n\n  .iconBox {\n    width: 42px;\n    height: 42px;\n    border-radius: 48px;\n  }\n\n  .iconBox svg {\n    max-width: 24px;\n    max-height: 24px;\n  }\n\n  .title {\n    line-height: normal;\n    letter-spacing: -0.5px;\n  }\n\n  .text {\n    font-size: 14px;\n    margin-top: 5px;\n  }\n\n  .title,\n  .text {\n    white-space: pre-wrap;\n  }\n\n  .exile {\n    font-size: 14px;\n    margin-top: 5px;\n    white-space: pre-wrap;\n  }\n}\n\n@media (min-width: 360px) and (max-width: 767px) {\n\n  .wrapper {\n    width: 158px;\n    height: 192px;\n    padding: 16px 12px;\n  }\n\n  .iconBox {\n    width: 42px;\n    height: 42px;\n  }\n\n  .iconBox svg {\n    max-width: 24px;\n    max-height: 24px;\n  }\n\n  .title {\n    line-height: normal;\n    letter-spacing: -0.5px;\n  }\n\n  .text {\n    font-size: 14px;\n    margin-top: 5px;\n  }\n\n  .exile {\n    font-size: 14px;\n    margin-top: 5px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Card-module__wrapper___KkGYa`,
	"iconBox": `Card-module__iconBox___DeDLc`,
	"title": `Card-module__title___GHLau`,
	"text": `Card-module__text___uBKO9`,
	"link": `Card-module__link___USksR`,
	"exile": `Card-module__exile___gv8F7`
};
export default ___CSS_LOADER_EXPORT___;
